import { useRouter } from 'expo-router'
import { TourCustomQuotePlanner } from '@/components/tours/TourCustomQuotePlanner'
import { previewCreateCustomTourQuote } from '../../preview/custom-tour-quote'
import { seedToursPreview } from '../../preview/seed'
import { PreviewSeedBoundary } from '../../preview/PreviewSeedBoundary'
import type { TourCustomQuoteInput, TourCustomQuoteResult } from '@/lib/types/tours.types'

function PreviewQuoteContent() {
  const router = useRouter()
  const handleQuote = async (input: TourCustomQuoteInput): Promise<TourCustomQuoteResult> => {
    const quote = await previewCreateCustomTourQuote(input)
    router.replace(`/preview/${quote.experienceId}`)
    return quote
  }

  return <TourCustomQuotePlanner onBack={() => router.back()} onQuote={handleQuote} />
}

export default function PreviewQuoteRoute() {
  return (
    <PreviewSeedBoundary seed={seedToursPreview} seedKey="custom-quote">
      <PreviewQuoteContent />
    </PreviewSeedBoundary>
  )
}
